import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterMondsee() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-mondsee-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-mondsee-heading">WETTER</h1>
        </div>

        <Wetter ort="mondsee" />
      </div>
    </div>
  );
}

export default WetterMondsee;
